import { memo, useEffect } from 'react';

export const RedirectExternal = memo(({ to }: { to: string }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);

  return null;
});
